import { Paper } from '@material-ui/core'
import React from 'react'
import { PaperProps } from '@material-ui/core/Paper'
import styled from '../../../theme'

type Type = React.ComponentType<PaperProps>
const PrintModalWrapper: Type = styled(Paper)<PaperProps>`
  border: none;
  outline: none;
  background-color: white;
  padding: 16px;
`

export default PrintModalWrapper
